import uniq from 'lodash/uniq';
import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import Flex from './Flex';
import Checkbox from './form/Checkbox';
import LinkButton from './LinkButton';
import Text from './Text';
const isRefined = (value, currentRefinement) => {
  return currentRefinement.includes(value);
};
const transformOverrideItems = (items, algoliaItems, currentRefinement) => {
  return items.map(item => {
    const algoliaItem = algoliaItems.find(i => item.value === i.label);
    const count = algoliaItem && algoliaItem.count ? algoliaItem.count : 0;
    return {
      ...item,
      count,
      isRefined: isRefined(item.value, currentRefinement)
    };
  });
};
const transformAlgoliaItems = (items, currentRefinement) => {
  return items.filter(item => !item.label.includes(',')).map(item => ({
    ...item
  }));
};
const AlgoliaChecklistRefinement = /*#__PURE__*/React.memo(_ref => {
  let {
    attribute,
    count,
    currentRefinement,
    deselectAll,
    flexDirection,
    fontSize,
    gutter,
    items: algoliaItems,
    itemsOverride,
    noResultsMessage,
    refine,
    selectAll,
    refinementMax
  } = _ref;
  const items = itemsOverride ? transformOverrideItems(itemsOverride, algoliaItems, currentRefinement) : transformAlgoliaItems(algoliaItems, currentRefinement);
  const handleChange = _ref2 => {
    let {
      target
    } = _ref2;
    if (itemsOverride) {
      refine(target.checked ? [...currentRefinement, target.value] : currentRefinement.filter(r => r !== target.value));
    } else {
      const item = items.find(i => i.label === target.value);
      refine(item && item.value ? item.value : []);
    }
  };
  const handleSelectAll = () => {
    if (itemsOverride) {
      refine(items.map(i => i.value));
    } else {
      refine(uniq(algoliaItems.reduce((values, item) => [...values, ...item.value], [])));
    }
  };
  const handleDeselectAll = () => {
    refine([]);
  };
  const showSelectAll = selectAll && !!(items.length && items.length !== currentRefinement.length);
  const showDeselectAll = deselectAll && !!(items && items.length) && !!(currentRefinement && currentRefinement.length);
  const canAddRefinement = !refinementMax || +refinementMax > currentRefinement.length;
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: flexDirection,
    fontSize: fontSize
  }, !items.length && /*#__PURE__*/React.createElement(Text, null, noResultsMessage), !canAddRefinement && /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold",
    color: "red"
  }, "Max options reached: ", refinementMax), (showSelectAll || showDeselectAll) && /*#__PURE__*/React.createElement(Flex, {
    mb: 2
  }, showSelectAll && /*#__PURE__*/React.createElement(LinkButton, {
    sx: {
      '&:hover': {
        color: 'secondary',
        textDecoration: 'underline'
      }
    },
    onClick: handleSelectAll,
    mr: "20px"
  }, "Select All"), showDeselectAll && /*#__PURE__*/React.createElement(LinkButton, {
    sx: {
      '&:hover': {
        color: 'secondary',
        textDecoration: 'underline'
      }
    },
    onClick: handleDeselectAll
  }, "Deselect All")), items.map((item, i) => /*#__PURE__*/React.createElement(Flex, {
    key: item.label,
    as: "label",
    sx: {
      alignItems: 'center',
      ml: i !== 0 && flexDirection === 'row' ? gutter : 0,
      mt: i !== 0 && flexDirection === 'column' ? gutter : 0
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: attribute,
    onChange: handleChange,
    value: itemsOverride ? item.value : item.label,
    checked: item.isRefined,
    disabled: !item.isRefined && !canAddRefinement
  }), /*#__PURE__*/React.createElement(Text, {
    sx: {
      '&:hover': {
        color: 'secondary',
        textDecoration: 'underline'
      }
    }
  }, getReadableLabel(item.label)), count && /*#__PURE__*/React.createElement(Text, {
    ml: 1,
    sx: {
      bg: 'gray.4',
      color: 'black',
      borderRadius: 'corner',
      px: '6px',
      ml: '6px',
      fontSize: '.9em',
      lineHeight: 1.2
    }
  }, item.count))));
});
const getReadableLabel = label => {
  if (label.includes('::')) return label.split('::')[1];
  return label;
};
AlgoliaChecklistRefinement.propTypes = {};
AlgoliaChecklistRefinement.defaultProps = {
  count: true,
  deselectAll: true,
  flexDirection: 'column',
  fontSize: 1,
  gutter: 1,
  selectAll: true,
  noResultsMessage: 'No matching results...',
  refinementMax: 10
};
AlgoliaChecklistRefinement.displayName = 'AlgoliaChecklistRefinement';
export default connectRefinementList(AlgoliaChecklistRefinement);